/**
 * Algorithm System Entry Point
 *
 * Initializes and exports the algorithm registry with all implementations.
 */

// Export price change utilities
export {
  calculatePriceChange,
  calculateSimplePriceChange,
  getTier,
} from "./price-change";

// Export registry
export { algorithmRegistry } from "./registry";
// Export types
export type {
  AlgorithmMetadata,
  ChipType,
  ConstructorRaceHistory,
  DriverRaceHistory,
  OptimalTeam,
  OptimalTeamsResult,
  PredictedConstructor,
  PredictedDriver,
  PredictionAlgorithm,
  PredictionResult,
  PriceChangeInput,
  PriceChangeResult,
  TeamCalculatorConstructor,
  TeamCalculatorData,
  TeamCalculatorDriver,
  TeamCalculatorRaceContext,
  WorkerInput,
  WorkerOutput,
} from "./types";

// Import V2 algorithm implementations
import { adaptiveAlgorithm } from "./implementations/adaptive";
import { hotStreakAlgorithm } from "./implementations/hot-streak";
import { momentumAlgorithm } from "./implementations/momentum";
import { recentFormAlgorithm } from "./implementations/recent-form";
import { seasonOverviewAlgorithm } from "./implementations/season-overview";

// Import registry
import { algorithmRegistry } from "./registry";

// Register all V2 algorithms
algorithmRegistry.register(adaptiveAlgorithm);
algorithmRegistry.register(momentumAlgorithm);
algorithmRegistry.register(recentFormAlgorithm);
algorithmRegistry.register(hotStreakAlgorithm);
algorithmRegistry.register(seasonOverviewAlgorithm);

// Set default algorithm
algorithmRegistry.setDefault("adaptive");

// Export individual algorithms for direct use if needed
export {
  adaptiveAlgorithm,
  hotStreakAlgorithm,
  momentumAlgorithm,
  recentFormAlgorithm,
  seasonOverviewAlgorithm,
};
